import React from 'react';
import {
  ContainerStyled,
  HeaderStyled,
  SubHeaderStyled,
  AltBodyStyled,
  WarningStyled,
} from './styles/ProcessingStyled';
import { ReactComponent as WarningIcon } from '../../../../images/ui/invoice-pay-warning.svg';
import { ReactComponent as LoadingIcon } from '../../../../images/ui/loading-hands-big.svg';

const Loading = () => {
  return (
    <ContainerStyled>
      <HeaderStyled>Espera un momento</HeaderStyled>
      <SubHeaderStyled>Estamos cargando tu bolsa</SubHeaderStyled>
      <LoadingIcon />
      <AltBodyStyled>
        <p>
          Si pierdes conexión, actualiza tu red WOM y volverás a estar conectado
          en unos segundos
        </p>
      </AltBodyStyled>
      <WarningStyled>
        <WarningIcon />
        <p>Te recomendamos activar y desactivar el modo avión de tu celular</p>
      </WarningStyled>
    </ContainerStyled>
  );
};

export default Loading;
